import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function WhoItsForSection() {
  const cards = [{
    title: 'Interior Designers',
    description: 'Source premium, unique pieces that elevate residential and commercial holiday installations.',
    image: 'https://cdn.magicpatterns.com/uploads/gXkZENQPtsnnNeJrF92kmH/hf_20260422_174351_7ae4c0c0-7e4f-473f-986e-3d7b7892d21a.png'
  }, {
    title: 'Retail Boutiques',
    description: "Stock high-margin, exclusive ornaments and décor that your customers won't find in big-box stores.",
    image: 'https://cdn.magicpatterns.com/uploads/auvVxrzwyxbAcTUqVnccoV/hf_20260422_174618_5e8bfdb9-18f3-4549-8596-054891b889e8.png'
  }, {
    title: 'Commercial Buyers',
    description: 'Reliable fulfillment for hotels, event planners, and institutions requiring large-scale displays.',
    image: 'https://cdn.magicpatterns.com/uploads/f6S4NJcsr969xPpDHC2gP3/hf_20260414_191954_ba4486ed-4f95-4e58-a74d-4f67444cea8e.png'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-tcp-black relative border-t border-white/5 pt-[30px] pb-[30px]" data-id="element-100">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-101">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-102">
          {cards.map((card, index) => <motion.div key={index} variants={cardVariants} whileHover={{
          y: -5,
          transition: {
            duration: 0.2
          }
        }} className="bg-tcp-pure-black border border-white/10 relative group overflow-hidden flex flex-col" data-id="element-103">
              {/* Top Accent Line */}
              <div className="absolute top-0 left-0 w-full h-1 bg-tcp-red transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out z-10" data-id="element-104" />

              {/* Image Header */}
              <div className="relative w-full h-56" data-id="element-105">
                <img src={card.image} alt={card.title} className="w-full h-full object-cover" data-id="element-106" />
                {/* Gradient Overlay to blend into card background */}
                <div className="absolute inset-0 bg-gradient-to-t from-tcp-pure-black via-tcp-pure-black/20 to-transparent" data-id="element-107" />
              </div>

              {/* Text Content */}
              <div className="p-10 pt-6 flex-1 flex flex-col" data-id="element-108">
                <h3 className="font-display text-2xl font-semibold text-white mb-4" data-id="element-109">
                  {card.title}
                </h3>

                <p className="text-gray-400 leading-relaxed" data-id="element-110">
                  {card.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}